// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1StateSchema } from './v1/stateSchema';
import { v1StatesUpdateSchema } from './v1/states/updateSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const updateStatePathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("State ID"),
});

export const updateStateHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description State updated successfully
 */
export const updateState200Schema = z.lazy(() => v1StateSchema);

/**
 * @description State not found
 */
export const updateState404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Validation failed
 */
export const updateState422Schema = z.lazy(() => v1ValidationErrorSchema);

export const updateStateMutationRequestSchema = z.lazy(() => v1StatesUpdateSchema);

export const updateStateMutationResponseSchema = z.lazy(() => updateState200Schema);
